import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getCurrentJwt } from "../utils/helpers/jwt.helpers";

//Utilizamos logica de Token para utilizar las ProtectedRoutes
//Solo utilizar si es necesario esta logica, en caso contrario utilizar rutas comunes (defininirlas en Router.js)

const ProtectedRoute = () => {
  const token = getCurrentJwt();
  if (!token || token === "undefined" || token === "null") {
    return <Navigate to={"/"} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
